import React from "react";
import styled from "styled-components";
import Markdown from "src/components/Markdown";
import TournamentHighlightedList from "./TournamentHighlightedList";
import TournamentDropDownText from "./TournamentDropDownText";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import TournamentDynamicTable from "./TournamentDynamicTable";

const TournamentSubtabsContent = ({ tournamentContent }) => {
  return (
    <Div>
      <container-div>
        <ContentText>
          <Markdown>{tournamentContent?.content?.text}</Markdown>
        </ContentText>

        {/* Use the HighlightedList component */}
        {tournamentContent?.content?.highlightedList && (
          <TournamentHighlightedList
            highlightedList={tournamentContent.content.highlightedList}
          />
        )}

        {tournamentContent?.content?.textTwo && (
          <ContentTextSmall>
            <Markdown>{tournamentContent?.content?.textTwo}</Markdown>
          </ContentTextSmall>
        )}

        {tournamentContent?.content?.centeredText && (
          <ContentCenteredText>
            <Markdown>
              {tournamentContent?.content?.centeredText}
            </Markdown>
          </ContentCenteredText>
        )}

        {/* Use the HighlightedListTwo component */}
        {tournamentContent?.content?.highlightedListTwo && (
          <TournamentHighlightedList
            highlightedList={tournamentContent.content.highlightedListTwo}
          />
        )}

        {tournamentContent?.content?.textThree && (
          <ContentTextSmall>
            <Markdown>
              {tournamentContent?.content?.textThree}
            </Markdown>
          </ContentTextSmall>
        )}

        {tournamentContent?.content?.smallText && (
          <Markdown>{tournamentContent?.content?.smallText}</Markdown>
        )}

        {tournamentContent?.content?.dropdownText && (
          <TournamentDropDownText
            dropdownText={tournamentContent?.content?.dropdownText}
          />
        )}

        {tournamentContent?.imageTextWrapper && (
          <ImageTextWrapper>
            <ResponsiveImage
              src={tournamentContent?.imageTextWrapper?.image}
              alt="text-image"
            />
            <Markdown>
              {tournamentContent?.imageTextWrapper?.text}
            </Markdown>
          </ImageTextWrapper>
        )}

        {tournamentContent?.content?.tableDataText && (
          <Markdown>
            {tournamentContent?.content?.tableDataText}
          </Markdown>
        )}

        {tournamentContent?.content?.tableData && (
          <TournamentDynamicTable
            tableData={tournamentContent?.content?.tableData}
          />
        )}

        {tournamentContent?.content?.tableDataTextTwo && (
          <Markdown>
            {tournamentContent?.content?.tableDataTextTwo}
          </Markdown>
        )}

        {tournamentContent?.content?.tableDataTwo && (
          <TournamentDynamicTable
            tableData={tournamentContent?.content?.tableDataTwo}
          />
        )}

        {tournamentContent?.content?.bottomText && (
          <Markdown>
            {tournamentContent?.content?.bottomText}
          </Markdown>
        )}
      </container-div>
    </Div>
  );
};
const Div = styled.div`
  padding-top: 20px;
  text-align: left;
`;
const ContentText = styled.div`
  p:first-child {
    padding: 0 20px 20px 20px;
    font-size: 18px;
    line-height: 26px;
    margin: 0px auto;
    max-width: 960px;
  }
`;
const ContentCenteredText = styled.div`
  p:first-child {
    padding: 0 20px 20px 20px;
    font-size: 18px;
    line-height: 26px;
    margin: 0px auto;
    max-width: 960px;
  }
`;
const ContentTextSmall = styled.div`
  text-align: center;
`;
const ImageTextWrapper = styled.div`
  margin: 20px 0;
  width: 100%;
  margin: 0 auto 40px auto;
  position: relative;
  z-index: 1;

  img {
    width: 100%;
    min-height: 200px;
    object-fit: cover;
  }

  p {
    position: absolute;
    padding: 10px 30px;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    color: white;
    font-weight: normal;
    text-align: center;
  }
  @media (max-width: 768px) {
    p {
      padding: 15px 20px;
      font-size: 14px;
    }
  }
`;

export default TournamentSubtabsContent;
